import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import {FlashMessagesService} from 'angular2-flash-messages';
import {Utils} from '../shared/utils';

import {Usuario} from '../usuario/usuario';
import {CadastroService} from './cadastro.service';

import {Formacao} from '../formocao/formacao';
import {FormacaoService} from '../formocao/formacao.service';
import {AppComponent} from "../app.component";
import {AcessoService} from "../acesso/acesso.service";


declare var jQuery: any;


@Component({
    selector: 'app-cadastro',
    templateUrl: './cadastro.component.html',
    styleUrls: ['./cadastro.component.css'],
    providers: [
        CadastroService,
        FormacaoService,
        AcessoService
    ],
})
export class CadastroComponent implements OnInit {

    usuario: Usuario;

    formacoes: Formacao[];
    public cpf_mask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public telefone_mask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    nome: string;
    email: string;
    emailConfirmacao: string;
    telefone: string;
    profissao: string;
    senha: string;
    senhaConfirmacao: string;
    cpf: number;
    instituicao_outros: boolean = false;
	genero_outro: string = null;
    flgErro = false;

    flgOnSubmit = false;
    msgOnSubmit = 'Cadastrando. Por favor, aguarde!';

    testaCPF() {
        let Soma;
        let Resto;
        Soma = 0;
        let strCPF = jQuery('#CPF').val();
        strCPF = strCPF.replace(/\D/g, '');
        // console.log(strCPF);
        if (strCPF === '00000000000') {
            this.utils.exibirMensagem('CPF Inválido.', 'danger');
            return false;
        }
        ;
        for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto === 10) || (Resto === 11)) Resto = 0;
        if (Resto !== parseInt(strCPF.substring(9, 10))) {
             this.utils.exibirMensagem('CPF Inválido.', 'danger');
            return false;
        }
        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto === 10) || (Resto === 11)) Resto = 0;

        if (Resto !== parseInt(strCPF.substring(10, 11))) {
            this.utils.exibirMensagem('CPF Inválido.', 'danger');
            return false;
        }

        return true;
    }

    onSubmit() {
        this.flgErro = false;
        let telefone = this.usuario.telefone.toString();
        telefone = telefone.replace(/\D/g,'');

        if (!this.testaCPF()) 
            this.flgErro = true;

        // console.log(telefone.length);
        // myString.replace(/\D/g,'');
        if (telefone.length < 10 || telefone.length > 11) {
            this.flgErro = true;
            this.utils.exibirMensagem('Telefone Inválido.', 'danger');
        }
		
		if (this.usuario.idade < 16) {
            this.flgErro = true;
            this.utils.exibirMensagem('Idade inválida.', 'danger');
        }
		
		let ano_atual = (new Date()).getFullYear();
		if (this.usuario.ano_ingresso < ano_atual - 20 || this.usuario.ano_ingresso > ano_atual) {
            this.flgErro = true;
            this.utils.exibirMensagem('Ano de ingresso inválido.', 'danger');
        }

        if (this.usuario.email.toUpperCase() !== this.emailConfirmacao.toUpperCase()) {
            this.flgErro = true;
			this.utils.exibirMensagem('Os emails não conferem.', 'danger');
        }

        if (this.usuario.senha !== this.usuario.senha_confirmation) {
            this.flgErro = true;
			this.utils.exibirMensagem('As senhas não conferem.', 'danger');
        }
		
		if (this.usuario.nome.trim().indexOf(" ") < 0)
		{
			this.flgErro = true;
			this.utils.exibirMensagem('O nome deve ser completo!', 'danger');
		}
		
		if (this.usuario.sexo == 'Outro')
			this.usuario.sexo = this.genero_outro;
		
        if (!this.flgErro) {
            this.save();
        } else {
            return false;
        }
    }

    save() {
        this.flgOnSubmit = true;
        this.cadastroService.save(this.usuario)
            .then(() => this.goBack());
        this.flgOnSubmit = false;

    }

    getUsuario(id: number): void {
        this.cadastroService.getUsuario(id)
            .then(usuario => this.usuario = usuario);
    }

    goBack(): void {
        this.router.navigate(['/acesso']);
    }
    aplicacao: AppComponent;

    constructor(private cadastroService: CadastroService,
                private route: ActivatedRoute,
                private location: Location,
                private formacaoService: FormacaoService,
                private flashMessagesService: FlashMessagesService,
                private acessoService: AcessoService,
                private router: Router,
				private utils: Utils) {
            // this.aplicacao = new AppComponent(this.acessoService, this.router);
            // if (!this.aplicacao.islogged()) {
            //     this.router.navigateByUrl('acesso');
            // }
        this.usuario = new Usuario;
    }

    getFormacoes(): void {
        this.formacaoService.getFormacoes()
            .then(formacao => this.formacoes = formacao);
    }

    maskcpf(field_id){
        let text = jQuery('#'+field_id).val();
        text=text.replace(/\D/g,""); //remove caracteres que não sejam números.

        //Aplica Mascara
        text=text.replace(/(\d{3})(\d)/,"$1.$2");   //Coloca ponto entre o terceiro e o quarto dígitos
        text=text.replace(/(\d{3})(\d)/,"$1.$2");   //Coloca ponto entre o setimo e o oitava dígitos
        text=text.replace(/(\d{3})(\d)/,"$1-$2");   //Coloca ponto entre o decimoprimeiro e o decimosegundo dígitos
        text=text.substr(0,14);
        // jQuery('#'+field_id).val(text);
        this.usuario.cpf=text;

        this.testaCPF();


    }

    maskphone(field_id){
        this.usuario.telefone=this.utils.maskphone(field_id);
    }
	
    trim(str) {
        str=str.toLowerCase();
        return str.replace(/^\s+|\s+$/g,"");
    }

    ngOnInit() {
        this.getFormacoes();
    }


}



// WEBPACK FOOTER //
// ./src/app/cadastro/cadastro.component.ts